export { default } from "./OrderHistoryDataConsent.page";
